import { render } from "./ImageDouble.vue?vue&type=template&id=2507abf8"
import script from "./ImageDouble.vue?vue&type=script&lang=js"
export * from "./ImageDouble.vue?vue&type=script&lang=js"

import "./ImageDouble.vue?vue&type=style&index=0&id=2507abf8&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__